import { SliderMedium } from '../../Slider/SliderMedium';

import { OfferCard } from './Card';
import { cardColors, cards } from './constants';

export const OffersBlockDesktop = () => (
  <SliderMedium heading="Офферы" subtitle="Лучшие предложения для монетизации трафика" dots autoplay>
    {cards.map((card, index) => (
      <OfferCard key={card.id} {...card} color={cardColors[index % cardColors.length]} />
    ))}
  </SliderMedium>
);
